import { dofusTiers, type Lang, type SuccessDef } from '@fakerpg/core';

const TIER_BY_TYPE: Record<string, string> = { toutou: 'one', golden: 'two', dark: 'three', diamond: 'four', king: 'five', six: 'six' };

/** Dofus tier an achievement's `%VAR%` stands for (the bot passes the tier emoji). */
export function successTier(def: SuccessDef): { key: string; emoji: string; name: string } | null {
  if (def.group !== 'toutous' || typeof def.value !== 'object' || def.value === null) return null;
  const key = TIER_BY_TYPE[String(def.value.type)];
  const tier = dofusTiers.find((d) => d.key === key);
  return tier ? { key: tier.key, emoji: tier.emoji, name: tier.name } : null;
}

export function successRawName(def: SuccessDef, lang: Lang): string {
  return def.name[lang] || def.name.fr;
}

/** Plain-text name (toasts, tooltips): emoji tokens and markdown removed, `%VAR%` → Dofus name. */
export function successPlainName(def: SuccessDef, lang: Lang): string {
  return successRawName(def, lang)
    .replace(/%VAR%/g, successTier(def)?.name ?? '')
    .replace(/<a?:[A-Za-z0-9_~]+:\d+>/g, '')
    .replace(/\*+/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
